import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

const _borderWidth = "2px";

export const checkboxStyles = () => {
    return css`
        align-items: flex-start;

        span[role="checkbox"] {
            border-width: ${_borderWidth};
            cursor: pointer;
            margin-top: 0.1em;
            font-size: ${TYPOGRAPHY.size.base};
            width: 1.15em;
            height: 1.15em;
            min-width: 1.15em;
            display: flex;
            justify-content: center;
            align-items: center;

            &[aria-checked="true"]:not([aria-disabled="true"]) {
                border: 2px solid ${getColor("secondary")};
                color: ${getContrastColor("common.background")};

                svg {
                    stroke: ${getColor("secondary")};
                }
            }

            &[aria-disabled="true"] {
                border: 2px solid ${getColor("common.disabledLight")};
                color: ${getColor("common.background")};
                background: ${getColor("common.background")};

                &:hover {
                    border: 2px solid ${getColor("common.disabledLight")};
                    cursor: not-allowed;
                }

                svg {
                    stroke: ${getColor("common.disabledLight")};
                    fill: ${getColor("common.disabledLight")};
                }
            }

            &[aria-checked="false"]:not([aria-disabled="true"]) {
                border: 2px solid ${getColor("tertiary")};
                color: ${getContrastColor("common.background")};
            }

            &[aria-checked="false"] svg {
                display: none;
            }

            &:focus {
                box-shadow: none;
                outline-color: ${getProp("theme.focus.color")};
                outline-style: ${getProp("theme.focus.style")};
                outline-width: ${_borderWidth};
                outline-offset: -${_borderWidth};
            }

            &:hover:not([aria-disabled="true"]) {
                border: 2px solid ${getColor("secondary")};
                color: ${getContrastColor("common.background")};
            }

            + label {
                margin: 0;
                padding-left: 0.7em;
            }

            &:not([aria-disabled="true"]) + label {
                cursor: pointer;
            }
        }
    `;
};
